import React, { Suspense, lazy } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import menuData from '../../routes'
import Login from '../../containers/login'
import EmailConfirmationPage from '../../containers/EmailConfirmationPage'
import ReConfirmationPage from '../../containers/ReConfirmationPage'
import AddCredit from '../../containers/addCredit'
import { AddCreditPlan } from '../../containers/settings/YourPlan'
import { componentLoader } from '../../utils'
import { Card } from 'antd'
import SuccessPage from '../success/list'
import FailedPage from '../failed/list'
import ForgotPage from '../forgotpassword'
import PageNotFound from './PageNotFound'
import DeptLeadset from '../department/deptLeadset'

import Deptname from '../department/deptname'

// import  DeptList from '../department/deptLeadsetData'

// import {
//     sip,
//     call,
//     registerSip,
//     unregisterSip,
//     answerCall,
//     startCall,
//     stopCall,
//   } from "react-sip";
//   import {
//     SIP_STATUS_DISCONNECTED,
//     //SIP_STATUS_...,
//     CALL_STATUS_IDLE,
//     //CALL_STATUS_...,
//     SIP_ERROR_TYPE_CONFIGURATION,
//     //SIP_ERROR_TYPE_...,
//     CALL_DIRECTION_INCOMING,
//     CALL_DIRECTION_OUTGOING,
//   } from "react-sip";
const AuthLayout = lazy(() => componentLoader(() => import('../../layouts/authLayout')))
const BasicLayout = lazy(() => componentLoader(() => import('../../layouts/basicLayout')))

export default (props) => {
    // console.log(props)
    const AppLoading = () => {
        return <Card loading={true}></Card>
    }
    return (
        <Suspense fallback={<AppLoading />}>
            <Switch>
                {menuData.map((item, key) => {
                    if (!item.children) {
                        return (<Route exact path={item.path} key={item.path} render={(route) => {
                            return <BasicLayout path={item.path} key={item.key == 'Reports' ? route?.location?.key : { key }} menuData={menuData} item={item}>
                                {!!item.component ?
                                    <Suspense fallback={<AppLoading />}>
                                        {item.component}
                                    </Suspense> : <></>}
                            </BasicLayout>
                        }} />)
                    }
                })}

                {menuData.map((item, key) => {
                    if (item.children) {
                        return item.children.map((child, k) => {
                            return (<Route exact path={child.path} key={child.path} render={(route) => {
                                return <BasicLayout path={child.path} menuData={menuData} item={item} >
                                    {!!child.component ?
                                        <Suspense fallback={<AppLoading />}>
                                            {child.component}
                                        </Suspense> : <></>}
                                </BasicLayout>
                            }} />)
                        })
                    }
                })}

                <Route exact path={'/'} key={'login'} render={(route) => <AuthLayout><Login /></AuthLayout>} />
                <Route path={'/payment/success/:id'} key={'success'} render={(route) => <SuccessPage />} />
                <Route exact path={'/payment/failed/:id'} key={'failed'} render={(route) => <FailedPage />} />
                <Route exact path={'/confirmation/:token'} key={'confirmation'} render={(route) => <EmailConfirmationPage />} />
                <Route exact path={'/password/forget/:uid/:token'} key={'forgot'} render={(route) => <ForgotPage />} />
                <Route exact path={'/reconfirmation'} key={'reconfirmation'} render={(route) => <ReConfirmationPage />} />
                <Route exact path={'/addcredit'} key={'addcredit'} render={(route) => <AddCredit />} />
                <Route exact path={"/DeptLeadset"} key={'deptLeadset'} render={(route) => <DeptLeadset />} />
                <Route exact path={"/Deptname"} key={'Deptname'} render={(route) => <Deptname />} />

                {/* <Route exact path={"/department1"} key={'DeptList'} render={(route) => <DeptList/>} /> */}

                {/* <Route exact path={'/signup'} key={'signup'} render={(route) => <Signup />} />
                <Route exact path={'/verify'} key={'otp'} render={(route) => <OTP />} /> */}

                <Route path='*'><PageNotFound /></Route>

            </Switch>
        </Suspense>
    )
};